import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";
import { useAppSelector } from "../app/hooks";
import { isAdminRole, UserRole } from "../app/userSlice";

export interface RequireSpecificRolesProps {
	requiredRoles?: UserRole[];
}

export default function RequireRoles({ requiredRoles }: RequireSpecificRolesProps) {
	const role = useAppSelector((state) => state.user.role);
	const navigate = useNavigate();

	useEffect(() => {
		if (role && requiredRoles && !requiredRoles.includes(role)) {
			isAdminRole(role) ? navigate("/adminHome") : navigate("/home");
		}
	}, [role, requiredRoles]);

	return <Outlet />;
}
